import React from 'react';
import { SpinnerIos20Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const SetupSuggestionLoader = ({ label = 'Loading recommendations…' }) => (
    <div className={styles.suggestionLoader} role="status" aria-live="polite">
        <SpinnerIos20Regular className={styles.suggestionLoaderIcon} />
        <p className={styles.suggestionLoaderLabel}>{label}</p>
    </div>
);

export default SetupSuggestionLoader;
